import React, {useEffect} from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {Stack, Text} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Progress} from '@chakra-ui/react'
import {useSiteContext} from '../../../contexts/site'
import useTagManager from '../../../hooks/use-tag-manager'

const BonusProgress = ({
    maxBonusItems,
    totalSelectedBonuses,
    bonusItemsInBasketArray,
    promotionDetails
}) => {
    const intl = useIntl()
    const {isYR} = useSiteContext()
    const tagManager = useTagManager()
    const variant = isYR ? 'yr' : 'ksGradient'
    const selectedItems =
        (bonusItemsInBasketArray?.reduce((sum, item) => {
            return sum + (item?.quantity || 0)
        }, 0) || 0) + totalSelectedBonuses // We'll respect bonus items that we are in the basket.
    const progress = (selectedItems / maxBonusItems) * 100

    useEffect(() => {
        let type /** page type **/
        if (document?.querySelector('.sf-product-list-page')) {
            type = 'plp'
        } else if (document?.querySelector('.sf-product-detail-page')) {
            type = 'pdp'
        } else {
            type = 'home'
        }
        let meterProgress /** meter progress **/
        if (!selectedItems) {
            meterProgress = 'Empty'
        } else if (selectedItems && selectedItems !== maxBonusItems) {
            meterProgress = 'Mid'
        } else {
            meterProgress = 'Full'
        }
        let meterType /** meter type **/
        if (promotionDetails?.id?.toLowerCase()?.indexOf('gwp') !== -1) {
            meterType = 'GWP'
        } else if (promotionDetails?.id?.toLowerCase()?.indexOf('pwp') !== -1) {
            meterType = 'PWP'
        } else {
            meterType = 'BMSM'
        }

        window.__dataLayerLoaded = true
        tagManager.promoMeterImpression(
            {
                id: promotionDetails.id,
                name: promotionDetails.name,
                creative: promotionDetails.details,
                position: type
            },
            meterType,
            meterProgress
        )
        window.__dataLayerLoaded = false
    }, [totalSelectedBonuses, selectedItems])
    return (
        <Stack gap={{base: '5px', xs: '10px'}} className="bonus-stack" isLoading={true}>
            <Text
                fontSize="16px"
                fontWeight="300"
                lineHeight="25px"
                className="bonus-stack-text"
                letterSpacing="0.08px"
                color="black.300"
            >
                <Text as="span" fontWeight="400" className="bonus-stack-text">
                    {selectedItems}{' '}
                    {intl.formatMessage({
                        id: 'gwp_modal.bonus_progress.of',
                        defaultMessage: 'of'
                    })}{' '}
                    {maxBonusItems}
                </Text>{' '}
                {intl.formatMessage({
                    id: 'gwp_modal.bonus_progress.bonus_products_selected',
                    defaultMessage: 'bonus products selected'
                })}
            </Text>

            <Progress value={progress} variant={variant} size="gwp" className="bonus-progress" />
        </Stack>
    )
}

BonusProgress.propTypes = {
    maxBonusItems: PropTypes.number.isRequired,
    promotionDetails: PropTypes.any,
    bonusItemsInBasketArray: PropTypes.any,
    totalSelectedBonuses: PropTypes.number.isRequired
}

export default BonusProgress
